import React, { useState } from "react";
import AddPOSModal from "./AddPOSModal";
import POSInventoryTable from "./POSInventoryTable";
import RackManagement from "./RackManagement";
import CycleCounting from "./CycleCounting";
import InventoryOperations from "./InventoryOperations";
import ReportsAndAnalytics from "./ReportsAndAnalytics";

const POSDashboard = () => {
  const [showAddPOSModal, setShowAddPOSModal] = useState(false);

  return (
    <div className="bg-gray-100 min-h-screen p-8">
      {/* Sections */}
      <div className="space-y-8">
        {/* Rack, Shelf, and Box Management */}
        <RackManagement />

        {/* Inventory Operations */}
        {/* <InventoryOperations /> */}

        {/* Inventory Table */}
        {/* <POSInventoryTable /> */}

        {/* Cycle Counting */}
        {/* <CycleCounting /> */}

        {/* Reports and Analytics */}
        {/* <ReportsAndAnalytics /> */}
      </div>
    </div>
  );
};

export default POSDashboard;
